
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocalOnly as ObiLocalOnlyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-local-only.js';
 
 
 

 
 export const ObiLocalOnly = createComponent({
   react: React,
   tagName: 'obi-local-only',
   elementClass: ObiLocalOnlyElement,
   events: {
     
   }
  });
 
 